import {
  Button,
  VStack,
  Container,
  Text,
  Image,
  usePrefersReducedMotion,
  keyframes,
  Box
} from "@chakra-ui/react";

import BackgroundImage from "../images/background-image.webp"
import Home1 from "../images/home1.webp";
import Home2 from "../images/home2.webp";
import Home3 from "../images/home3.webp";
import Home4 from "../images/home4.webp";
interface HomeViewProps {
}

const HomeView: React.FC<HomeViewProps> = () => {
  const handleGetStarted = () => {
    window.open('https://linktr.ee/daolabs');
  }

  return (
    <>
      <Box
        position={"fixed"}
        backgroundImage={`url(${BackgroundImage})`}
        backgroundSize="cover"
        width={'100%'}
        height={'100%'}
        opacity={0.5}
        zIndex={-3}
      />

      <Container centerContent maxWidth={1280} position='relative'>
        <VStack zIndex={2}>
          <Text fontSize={'3xl'} mt={8} mb={16} px={6} borderRadius={24} bgColor='black'>Home</Text>
          <Button
            size={'lg'}
            bgGradient='linear(to-b, rgb(86, 170, 204) 0%, rgb(23, 21, 21) 40%)'
            _hover={{
              bgGradient: 'linear(to-b, rgb(86, 170, 204) 0%, rgb(23, 21, 21) 75%)'
            }}
            onClick={handleGetStarted}>Get Started</Button>
        </VStack>

        <FloatingImage
          left={"auto"}
          right={"-10%"}
          top={"-10%"}
          bottom={"auto"}
          image={Home1}
          blur={"10px"}
          delay={"1s"} />

        <FloatingImage
          top={"10%"}
          left={"-10%"}
          image={Home2}
          blur={"10px"}
          delay={"0s"} />

        <FloatingImage
          left={"16%"}
          top={"124%"}
          image={Home3}
          blur={"6px"}
          delay={"2s"} />

        <FloatingImage
          right={"16%"}
          top={"90%"}
          image={Home4}
          blur={"10px"}
          delay={"3s"} />
      </Container>
    </>
  );
};

export default HomeView;

interface FloatingImageProps {
  image: string
  blur: string
  left?: string
  top?: string
  right?: string
  bottom?: string
  delay: string
}

function FloatingImage(props: FloatingImageProps) {
  const { image, blur, left, top, right, bottom, delay } = props;

  const fly = keyframes`
  from { transform: translate3d(0px, 0px, 0px) }
  to { transform: translate3d(0px, 12px, 0px) }
  `;

  const prefersReducedMotion = usePrefersReducedMotion();

  const animation = prefersReducedMotion
    ? undefined
    : `${fly} infinite 2s ease`;

  return (
    <Image
      width={{ base: 128, sm: 128, md: 256 }}
      height={{ base: 128, sm: 128, md: 256 }}
      position={"absolute"}
      animation={animation}
      sx={{ animationDirection: "alternate", animationDelay: delay }}
      transition={"all 300ms ease"}
      filter={"auto"}
      blur={blur}
      _hover={{
        blur: 0,
        zIndex: 2,
      }}
      borderRadius={16}
      src={image}
      objectFit={'cover'}
      left={left}
      top={top}
      right={right}
      bottom={bottom}
    />
  );
}